export default __webpack_public_path__ + "static/media/Zahl-6.1508c0a9.png";